/**
 * 模型类型配置
 */
export const modelTypes = [
  {
    value: 'ORITEK' as const,
    label: '欧冶模型',
    description: '适配欧冶系列模型格式转换',
  },
  {
    value: 'HUAWEI' as const,
    label: '华为模型',
    description: '适配华为系列模型格式转换',
  },
];

export const APP_VERSION = process.env.APP_VERSION ?? 'dev';

const getAppEnv = (): 'dev' | 'test' | 'production' => {
  if (APP_VERSION.startsWith('dev')) return 'dev';

  return APP_VERSION.startsWith('test') ? 'test' : 'production';
};

export const APP_ENV = getAppEnv();

export const __DEV__ = APP_ENV === 'dev';
